import { Heading, Image } from "capitalrx-components-2.0";

import VideoBackground from "./VideoBackground";
import styles from "./HomeHero.module.scss";
import HeroCardImage from "@/static/images/discount-card-min.png";

import FindBestPriceSearch from "../FindBestPriceSearch";

const HomeHero = (): JSX.Element => {
  const { H1 } = Heading;

  return (
    <div className={styles.HomeHeroWrapper}>
      <VideoBackground />

      <div className={styles.HomeHeroContainer}>
        <div className={styles.HomeHeroHeader}>
          <H1 roboto className={styles.HomeHeroMainHeading} testId="advantage-main-heading">
            Save up to 90% on your prescriptions
          </H1>
          <span data-testid="advantage-heading-subtext">with the FREE Capital Rx Advantage card*</span>
          <p className={styles.HomeHeroCaveat}>*Based on the difference between the U&C submitted by the pharmacy and the price the patients pay</p>
        </div>
        <div className={styles.HomeHeroFindBestPriceSearchWrapper}>
          <FindBestPriceSearch />
        </div>
        <div className={styles.HomeHeroCardImage}>
          <Image src={HeroCardImage} alt="Advantage Discount Card" ariaHidden="true" testId="advantage-card-image" />
        </div>
      </div>
    </div>
  );
};

export default HomeHero;
